export const formatTime = (timestamp, isLocalTimezone = false) => {
  const date = new Date(timestamp * 1000);

  let year, month, day, hours, minutes, seconds;

  if (isLocalTimezone) {
    year = date.getFullYear();
    month = String(date.getMonth() + 1).padStart(2, '0');
    day = String(date.getDate()).padStart(2, '0');
    hours = String(date.getHours()).padStart(2, '0');
    minutes = String(date.getMinutes()).padStart(2, '0');
    seconds = String(date.getSeconds()).padStart(2, '0');
  } else {
    year = date.getUTCFullYear();
    month = String(date.getUTCMonth() + 1).padStart(2, '0');
    day = String(date.getUTCDate()).padStart(2, '0');
    hours = String(date.getUTCHours()).padStart(2, '0');
    minutes = String(date.getUTCMinutes()).padStart(2, '0');
    seconds = String(date.getUTCSeconds()).padStart(2, '0');
  }

  return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
};

export const getLocalTimezone = () => {
  const date = new Date();
  const timezoneOffset = date.getTimezoneOffset();
  const hours = Math.floor(Math.abs(timezoneOffset) / 60);
  const minutes = Math.abs(timezoneOffset) % 60;
  const sign = timezoneOffset <= 0 ? '+' : '-';

  return `GMT${sign}${hours}${minutes > 0 ? ':' + String(minutes).padStart(2, '0') : ''}`;
};

export default formatTime;
